import React, { useState, Fragment } from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
const mockSections = [{
  id: 1,
  name: 'Section 3',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 2,
  name: 'Section 4',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 3,
  name: 'Section 5',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 4,
  name: 'Section 1',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 5,
  name: 'Section 2',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 6,
  name: 'Section 3',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 7,
  name: 'Section 4',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 8,
  name: 'Section 5',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'BMC #1B Property Management'
}, {
  id: 9,
  name: 'Section 1',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 10,
  name: 'Section 2',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Avoid The Oops: Contract Smarts for Agents'
}, {
  id: 11,
  name: 'Section 1',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 12,
  name: 'Section 2',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 13,
  name: 'Section 3',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 14,
  name: 'Section 4',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 15,
  name: 'Section 5',
  questionTypes: '',
  requiredTime: 25,
  position: '',
  course: 'Broker Management Clinic'
}, {
  id: 16,
  name: 'sdgdg',
  questionTypes: 'M',
  requiredTime: 5,
  position: '0',
  course: ''
}, {
  id: 17,
  name: 'xcbxcbxcxcb',
  questionTypes: 'M',
  requiredTime: 5,
  position: '0',
  course: ''
}, {
  id: 18,
  name: 'Section 2',
  questionTypes: '',
  requiredTime: 0,
  position: '0',
  course: ''
}, {
  id: 19,
  name: 'Section 1',
  questionTypes: '',
  requiredTime: 0,
  position: '0',
  course: ''
}, {
  id: 20,
  name: 'test8',
  questionTypes: 'M',
  requiredTime: 5,
  position: '0',
  course: ''
}];
export function CourseSections() {
  const navigate = useNavigate();
  const [selectedCourse, setSelectedCourse] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  return <div className="space-y-4" data-id="element-324" data-mp="1kku0mc8olis1">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-325" data-mp="1kjskvugq083z">Course Sections</h1>

      {/* Filters */}
      <div className="space-y-2" data-id="element-326" data-mp="1fm970vnxpxck">
        <div data-id="element-327" data-mp="1aur3bzuj1inw">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-328" data-mp="1au8zoi5jc25y">Courses</label>
          <select value={selectedCourse} onChange={e => setSelectedCourse(e.target.value)} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[240px]" data-id="element-329" data-mp="15vnzgiqa9ihi">
            <option value="" data-id="element-330" data-mp="1yi8rllel1ym4">All</option>
            <option value="avoid" data-id="element-331" data-mp="1j1siy212qny4">
              Avoid The Oops: Contract Smarts for Agents
            </option>
            <option value="bmc" data-id="element-332" data-mp="1o2gacot7t6sv">BMC #1B Property Management</option>
            <option value="broker" data-id="element-333" data-mp="194e58a6jcd9i">Broker Management Clinic</option>
          </select>
        </div>
        <div data-id="element-334" data-mp="1e2z7ef5cl70l">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-335" data-mp="1e2pfun4nmrss">
            Sections
          </label>
          <select value={selectedSection} onChange={e => setSelectedSection(e.target.value)} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[120px]" data-id="element-336" data-mp="21sjpywxla29c">
            <option value="" data-id="element-337" data-mp="1x1tohusaajjx">All</option>
          </select>
        </div>
        <div className="flex items-center gap-4" data-id="element-338" data-mp="1x00h2d9ujvav">
          <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-339" data-mp="2kqmmdwsgv1h6">
            Search
          </Button>
          <div className="flex items-center gap-2" data-id="element-340" data-mp="e1korbgzqg3h">
            <span className="text-sm text-slate-600" data-id="element-341" data-mp="953yaambjpn8">course id:</span>
            <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/sections/add')} data-id="element-342" data-mp="nt8ixk4xmb8n">
              <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-343" data-mp="3ra76w5bhujse" />
              Add
            </Button>
          </div>
        </div>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-344" data-mp="44zikmt8iyy2">
        <div className="overflow-x-auto" data-id="element-345" data-mp="434wh56890se">
          <table className="w-full text-sm text-left" data-id="element-346" data-mp="3e6v4sfsqpg">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-347" data-mp="60et5j8p887">
              <tr data-id="element-348" data-mp="1fith3pw0dnq1">
                <th className="px-4 py-3 border-r border-slate-700" data-id="element-349" data-mp="1fmhbssd6wg6c">Name</th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-28" data-id="element-350" data-mp="1bi19t26p5swe">
                  Question Types
                </th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-28" data-id="element-351" data-mp="d6zzeteab2bz">
                  Required Time
                </th>
                <th className="px-4 py-3 border-r border-slate-700 text-center w-24" data-id="element-352" data-mp="i74huoyr674u">
                  Position
                </th>
                <th className="px-4 py-3 border-r border-slate-700" data-id="element-353" data-mp="m6vevaevhjht">Courses</th>
                <th className="px-4 py-3 text-center w-36" data-id="element-354" data-mp="3lo33h3hue3lf">
                  <div data-id="element-355" data-mp="3qlms8xc61yrm">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-356" data-mp="3qmo95ifv5fh9">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-357" data-mp="39ltvotwfxyg">
              {mockSections.map(row => <tr key={row.id} className="hover:bg-slate-50" data-id="element-358" data-mp="32viompyz9z0m">
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-359" data-mp="36xdpxugwscee">
                    {row.name}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-360" data-mp="2zd37g2ay61a9">
                    {row.questionTypes}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-361" data-mp="2qdohr52ltuqt">
                    {row.requiredTime || ''}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-362" data-mp="2ldtqv1itx55r">
                    {row.position}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-363" data-mp="2bosbndk3yrsu">
                    {row.course && <button className="text-blue-600 hover:underline text-left" data-id="element-364" data-mp="26pfoerpbripq">
                        {row.course}
                      </button>}
                  </td>
                  <td className="px-4 py-2.5 text-center" data-id="element-365" data-mp="1xp0z7h98pjgy">
                    <div className="flex items-center justify-center gap-2" data-id="element-366" data-mp="1xo95yd347xtu">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/sections/view/${row.id}`)} data-id="element-367" data-mp="1sqzbgj0vcvz5">
                        <Eye className="h-4 w-4" data-id="element-368" data-mp="3ljcm8xdnqeoo" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/sections/edit/${row.id}`)} data-id="element-369" data-mp="37lo4vzistpod">
                        <Edit className="h-4 w-4" data-id="element-370" data-mp="32ne67exv86y0" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-371" data-mp="2ovg5nsi7zjdg">
                        <Trash2 className="h-4 w-4" data-id="element-372" data-mp="2sxb50rglbmol" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-373" data-mp="20al67elq2a4u">
        <button className="hover:underline" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} data-id="element-374" data-mp="20cnthqvhpp5v">
          &lt;&lt; previous
        </button>
        <span className="text-slate-400" data-id="element-375" data-mp="2aac13he72r5g">|</span>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n, i) => <Fragment key={n} data-id="element-376" data-mp="25837cithzl2a" data-mpi={i}>
            {i > 0 && <span className="text-slate-400" data-id="element-377" data-mp="2j9fk6ldd36jy">|</span>}
            <button onClick={() => setCurrentPage(n)} className={`hover:underline ${currentPage === n ? 'text-slate-900 font-medium' : ''}`} data-id="element-378" data-mp="2j7upmvr1rnm3">
              {n}
            </button>
          </Fragment>)}
        <span className="text-slate-400" data-id="element-379" data-mp="2o0finv24pwok">|</span>
        <button className="hover:underline" onClick={() => setCurrentPage(Math.min(9, currentPage + 1))} data-id="element-380" data-mp="2o0ntziilstxn">
          next &gt;&gt;
        </button>
      </div>
    </div>;
}